import { useRef, useState } from "react";
import { Button } from "@/components/ui/button";
import { Bold, Italic, List, ListOrdered, Link as LinkIcon, Heading2, Heading3, Quote, Image as ImageIcon } from "lucide-react";

const cmd = (name, value = null) => {
  document.execCommand(name, false, value);
};

export default function RichTextEditor({ value, onChange }) {
  const ref = useRef(null);
  const [initialised, setInitialised] = useState(false);

  const setRef = (el) => {
    ref.current = el;
    if (el && !initialised && value) {
      el.innerHTML = value;
      setInitialised(true);
    }
  };

  const handleInput = () => {
    onChange(ref.current?.innerHTML || "");
  };

  const insertHeading = (level) => {
    cmd("formatBlock", `<H${level}>`);
    handleInput();
  };

  const insertLink = () => {
    const url = window.prompt("Link-URL (z. B. /artikel/…)");
    if (url) cmd("createLink", url);
    handleInput();
  };

  const insertImage = () => {
    const url = window.prompt("Bild-URL (oder Data-URL)");
    if (url) cmd("insertImage", url);
    handleInput();
  };

  const btnClass = "h-9 w-9 p-0 border border-neutral-200 bg-white hover:bg-neutral-50";

  return (
    <div className="border border-neutral-200 bg-white">
      <div className="flex flex-wrap gap-1 p-2 border-b border-neutral-200 bg-neutral-50">
        <Button type="button" variant="ghost" className={btnClass} onClick={() => { cmd("bold"); handleInput(); }} data-testid="editor-bold"><Bold size={14} /></Button>
        <Button type="button" variant="ghost" className={btnClass} onClick={() => { cmd("italic"); handleInput(); }} data-testid="editor-italic"><Italic size={14} /></Button>
        <Button type="button" variant="ghost" className={btnClass} onClick={() => insertHeading(2)} data-testid="editor-h2"><Heading2 size={14} /></Button>
        <Button type="button" variant="ghost" className={btnClass} onClick={() => insertHeading(3)} data-testid="editor-h3"><Heading3 size={14} /></Button>
        <Button type="button" variant="ghost" className={btnClass} onClick={() => { cmd("insertUnorderedList"); handleInput(); }} data-testid="editor-ul"><List size={14} /></Button>
        <Button type="button" variant="ghost" className={btnClass} onClick={() => { cmd("insertOrderedList"); handleInput(); }} data-testid="editor-ol"><ListOrdered size={14} /></Button>
        <Button type="button" variant="ghost" className={btnClass} onClick={() => { cmd("formatBlock", "<BLOCKQUOTE>"); handleInput(); }} data-testid="editor-quote"><Quote size={14} /></Button>
        <Button type="button" variant="ghost" className={btnClass} onClick={insertLink} data-testid="editor-link"><LinkIcon size={14} /></Button>
        <Button type="button" variant="ghost" className={btnClass} onClick={insertImage} data-testid="editor-image"><ImageIcon size={14} /></Button>
      </div>
      <div
        ref={setRef}
        contentEditable
        suppressContentEditableWarning
        onInput={handleInput}
        onBlur={handleInput}
        className="min-h-[420px] p-6 prose-editorial focus:outline-none"
        data-testid="editor-content"
      />
    </div>
  );
}
